import React, { useState } from 'react'
import { CurrentRefinementsProvided } from 'react-instantsearch-core'
import { Configure, InstantSearch, connectCurrentRefinements } from 'react-instantsearch-dom'

import { FilterResetContext, RecipesInspirationFilter } from './components/RecipesInspirationFilter'
import { RecipesInspirationResult } from './components/RecipesInspirationResult'

import { BackToTopButton, Button, PageLayout } from 'Components'
import { Icon, IconColor, IconName } from 'Components/Icon'
import { CustomSearchBox } from 'Components/Search/searchHelpers'
import { AlgoliaIndexName, getIndexName, searchClient } from 'Utils/algoliaSearchHelpers'

const RecipesInspirationPage: React.FC = () => {
  const [filterResetVersion, setFilterResetVersion] = useState(0)

  return (
    <PageLayout variant="smallcircle" style={{ paddingTop: '3.5rem' }}>
      <div className="container">
        <div className="row">
          <InstantSearch indexName={getIndexName(AlgoliaIndexName.RECIPES_INSPIRATION)} searchClient={searchClient}>
            <Configure hitsPerPage={100} />

            <FilterResetContext.Provider value={filterResetVersion}>
              <div className="col-12">
                <div className="row align-items-center g-2 justify-content-between">
                  <div className="col-12 col-lg-8">
                    <CustomSearchBox labelText="Rezepte suchen …" />
                  </div>

                  <div className="col-12 col-lg-2">
                    <ClearAllFiltersButton onClear={() => setFilterResetVersion((version) => version + 1)} />
                  </div>
                </div>
              </div>

              <RecipesInspirationFilter />

              <RecipesInspirationResult />
            </FilterResetContext.Provider>
          </InstantSearch>
        </div>
      </div>

      <BackToTopButton />
    </PageLayout>
  )
}

type ClearAllFiltersButtonProps = CurrentRefinementsProvided & {
  onClear: () => void
}

const ClearAllFiltersButton = connectCurrentRefinements(({ items, refine, onClear }: ClearAllFiltersButtonProps) => (
  <Button
    theme="tiny"
    disabled={items.length === 0}
    onClick={() => {
      refine(items)
      onClear()
    }}
  >
    <span className="d-flex align-items-center justify-content-center">
      <Icon name={IconName.refresh} color={IconColor.WHITE} ariaHidden style={{ marginRight: 8 }} />
      Filter zurücksetzen
    </span>
  </Button>
)) as React.ComponentType<{ onClear: () => void }>

export default RecipesInspirationPage
